<ndt-account-verification-view
   (formSubmitted)="onSubmit($event)"
   [submitState$]="submitState$"
   [callState]="callState$ | async"
   [canAccountBeFinalized]="canAccountBeFinalized$ | async"
   [emailAddress]="emailAddress$ | async"
>
</ndt-account-verification-view>
